@if (vpImage.src && imageWidth) {
	<vp-image [editableInStoryblok]="_editable" [image]="vpImage" />
}
